import React from 'react';
import { DefaultButton, Stack, Text } from 'office-ui-fabric-react';
import { actions } from '../actions';
import { connect } from 'react-redux';
var TodoFooter = function (props) {
    var todos = props.todos, clear = props.clear;
    var itemCount = Object.keys(todos).filter(function (id) { return !todos[id].completed; }).length;
    return (React.createElement(Stack, { horizontal: true, horizontalAlign: "space-between", verticalAlign: "center" },
        React.createElement(Text, null,
            itemCount,
            " item",
            itemCount === 1 ? '' : 's',
            " left"),
        React.createElement(DefaultButton, { onClick: function () { return clear(); } }, "Clear Completed")));
};
var ConnectedTodoFooter = connect(function (state) { return ({
    todos: state.todos
}); }, function (dispatch) { return ({
    clear: function () { return dispatch(actions.clear()); }
}); })(TodoFooter);
export { ConnectedTodoFooter as TodoFooter };
